import React, { useCallback, useEffect, useRef, useState } from "react";
import { s3baseUri } from "../../../../config/config";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import {
  get_blog_type_for_feature,
  getReadingTime,
} from "../../../../utils/Constant";
import InsightCard from "./components/InsightCard";
import AddOrUpdateInsightModal from "./components/AddOrUpdateInsightModal";
import { useNavigate, useParams } from "react-router-dom";
import { get_blogs_listing } from "../../../../DAL/blogs/BlogList";
import { enqueueSnackbar } from "notistack";
import RecordNotFound from "../../../../components/recordNotFound/RecordNotFound";
import CircularLoader from "../../../../components/loader/CircularLoader";
import InsightsFilter from "./components/InsightsFilter";
import GeneralMUIDialog from "../../../../components/GeneralMUIDialog/GeneralMUIDialog";
import TopBar from "../components/TopBar";
import { useIds } from "../../../../hook/AdminContext";
import AppliedFilters from "../../../../components/AppliedFilters/AppliedFilters";
import { CircularProgress } from "@mui/material";
import Pagination from "../../../../components/Pagination/Pagination";
import CommingSoon from "../../../../components/recordNotFound/CommingSoon";
import { plus } from "../../../../assets";

export default function InsightsPage({
  searchText = "",
  filterModal,
  contentData = null,
  setFilterModal,
  companyType,
  setOpenEditProfileModal,
}) {
  const { feature_slug, source_slug } = useParams();
  const navigate = useNavigate();
  const { userInfo, handleGetSectorAccessValue } = useIds();
  const [filterData, setFilterData] = useState({
    category: null,
    list: "all",
  });
  const [insightsToShow, setInsightsToShow] = useState("");
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);

  const topBarList = [
    {
      id: "",
      title: "All Insights",
    },
    {
      id: userInfo.profile_id,
      title: "My Insights",
    },
  ];

  const [loading, setLoading] = useState(true);
  const [insightsListing, setInsightsListing] = useState([]);
  console.log(insightsListing, "insightsListing");

  // load more functionality
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setPageNumber(pageNumber + 1);
    handleGetInsightsList(pageNumber + 1, true);
  };

  const [openADDEditInsightModal, setOpenADDEditInsightModal] = useState(false);
  const [targetInsight, setTargetInsight] = useState(null);

  const handleInsightClick = (blog) => {
    navigate(
      `/${source_slug}/feature/${feature_slug}/insight-details/${blog.slug}`,
      {
        state: { blog: blog, tab: "insights" },
      }
    );
  };
  const handleAddInsights = () => {
    if (userInfo?.[companyType]?.publish) {
      setOpenADDEditInsightModal(true);
    } else {
      setOpenEditProfileModal(true);
    }
  };

  const handleGetInsightsList = async (page = 0, loadingMore = false) => {
    if (!loadingMore) {
      setLoading(true);
    }
    const resp = await get_blogs_listing(
      source_slug,
      feature_slug,
      searchText,
      filterData?.category?.title_slug,
      insightsToShow,
      page,
      limit
    );
    if (resp.code == 200) {
      if (loadingMore) {
        let list = insightsListing.concat(resp.blog);
        setInsightsListing(list);
      } else {
        setInsightsListing(resp.blog);
      }
      setAppliedFilterData(filterData);
      setTotalPages(resp.total_pages || 0);
      setTotalCount(resp.total_blogs || 0);
      setPageNumber(page);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsLoadingMore(false);
    setLoading(false);
  };

  const handleFilterData = () => {
    setFilterModal(false);
    handleGetInsightsList();
  };
  useEffect(() => {
    handleGetInsightsList();
  }, [searchText, insightsToShow, filterChange]);

  return (
    <>
      {openADDEditInsightModal && (
        <AddOrUpdateInsightModal
          open={openADDEditInsightModal}
          onClose={() => {
            setOpenADDEditInsightModal(false);
            setTargetInsight(null);
          }}
          handleGetInsightsList={handleGetInsightsList}
          editData={targetInsight} // if not null, update mode
        />
      )}

      {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          title="Filter"
          actionText="Filter"
          content={
            <InsightsFilter inputs={filterData} setInputs={setFilterData} />
          }
          onSubmit={handleFilterData}
        />
      )}
      <div className="overview-coaches my-3" id="insights-container">
        <div className=" heading-main-hr d-flex my-2 justify-content-between align-items-center flex-column flex-md-row flex-nowrap">
          <h6 className="mb-0">{contentData?.insights.heading}</h6>

          {feature_slug != "leaders-in-the-industry" &&
            handleGetSectorAccessValue(
              get_blog_type_for_feature(feature_slug)
            ) &&
            ((userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
              (userInfo?.isCompanyProfile &&
                userInfo?.company_access?.manage_profile?.company_profile)) && (
              <div className="d-flex align-items-center">
                <TopBar
                  classes="tw-w-[250px] me-3 tw-mb-3"
                  items={topBarList}
                  cardToOpen={insightsToShow}
                  setCardToOpen={(value) => {
                    setInsightsToShow(value);
                  }}
                />

                <button
                  className="outlined-btn tw-mb-3 py-3"
                  onClick={() => handleAddInsights()}
                >
                  <img
                    src={plus}
                    className="img-fluid"
                    alt=""
                    height={20}
                    width={20}
                  />{" "}
                  Add New Insight
                </button>
              </div>
            )}
        </div>

        {appliedFilterData && (
          <div>
            <AppliedFilters
              filterData={appliedFilterData}
              setFilterData={setFilterData}
              onFilterChange={() => {
                setFilterChange(!filterChange);
              }}
            />
          </div>
        )}

        {loading ? (
          <CircularLoader />
        ) : (
          <div className="row px-2">
            {insightsListing.length > 0 ? (
              <>
                {insightsListing.map((post) => (
                  <div className="col-12 mb-3">
                    <InsightCard
                      post={post}
                      handleOpenEditCoach={(blog) => {
                        setTargetInsight(blog);
                        setOpenADDEditInsightModal(true);
                      }}
                      handleGetInsightListing={handleGetInsightsList}
                      handleInsightClick={handleInsightClick}
                    />
                  </div>
                ))}

                {/* {!loading &&
                  totalPages > 1 &&
                  totalPages > pageNumber &&
                  insightsListing.length > 0 && (
                    <div className="col-12 text-center mt-3">
                      <div
                        ref={lastBookElementRef}
                        className="mt-3"
                        onClick={() => {
                          handleLoadMore();
                        }}
                        id="load-more-feed"
                      >
                        {isLoadingMore ? (
                          <CircularProgress size={15} />
                        ) : (
                          "Load More"
                        )}
                      </div>
                    </div>
                  )} */}

                <Pagination
                  currentPage={pageNumber}
                  totalCount={totalCount}
                  pageSize={limit}
                  fetchData={(page) => handleGetInsightsList(page)}
                  loading={isLoadingMore}
                  paginationFor={"insights"}
                  conatinerId={"insights-container"}
                />
              </>
            ) : (
              <div className="text-center">
                {/* <img
                src="/img/not-found.png"
                alt="No Image Available"
                className="empty-img"
              />
              <h3>Sorry! No insights matching your search.</h3>
              <p>Try different category or keywords.</p> */}

                {feature_slug == "leaders-in-the-industry" ? (
                  <CommingSoon />
                ) : (
                  <RecordNotFound title="No Insights" />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
